'use strict';

import React, { Component } from 'react';
import ValidationOverlay from'./validationOverlay.jsx';
import Moment from 'moment';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { Box, Grid } from '@material-ui/core';
import { InputSelectMagasin, InputSelectNative } from '../../../commonModules/interface/form-input-inline.jsx';
var $ = require('jquery');

class NewBoxAssociation extends Component{
 emptyTable = [
            {
                id: "",
                value: ""
            }
        ]
        state = {
            //Initiate Default User
            msg: "",
            popupState: this.props.popupState,
            popupStateValidation: false,
            boxlistValue: "",
            boxlist: this.emptyTable,
            subscriptionlistValue: "",
            subscriptionlist: this.emptyTable,
            simlistValue: "",
            simlist: this.emptyTable,
            errmsg: "",
            url: ""
        }
    onValidation = async (e) => {
        e.preventDefault();
        //Test if ok
        if (this.state.boxlistValue === '') {
            this.setState({errmsg: "Numéro de Box  can not be empty"});
            return;
        }
        if (this.state.simlistValue === '') {
            this.setState({errmsg: "Numero de SIM can not be empty"});
            return;
        }
        /*
        if (this.state.subscriptionlistValue === '') {
            this.setState({errmsg: "Type d'abonnement  can not be empty"});
            return;
        }*/
        var subscriptionId = "";
        for (var i = 0; i < this.state.subscriptionlist.length; i += 1) {
            if (this.state.subscriptionlist[i].id=== this.state.subscriptionlistValue){
                subscriptionId = this.state.subscriptionlist[i].idobj;
            }
        }
        /*if (subscriptionId===''){
          this.setState({errmsg: "Type d'abonnement Id can not be empty. Reload Page"});
          return;
        }*/
        var simId = "";
        for (var i = 0; i < this.state.simlist.length; i += 1) {
            if (this.state.simlist[i].id=== this.state.simlistValue){
                simId = this.state.simlist[i].idobj;
            }
        }
        if (simId===''){
            this.setState({errmsg: "Numero de SIMId can not be empty. Reload Page"});
            return;
        }
        var msg = "Record Association id sytème : " + this.state.boxlistValue + ", sim : " + this.state.simlistValue + ", Contrat : " + this.state.subscriptionlistValue;
        var url = "association/new?boxid=" + this.state.boxlistValue + "&sim=" + simId + "&contract=" + subscriptionId;
        //Active Pop up Security
        this.setState({popupStateValidation: true, msg: msg, url: url});
    }
    // onClose= async (e) => {
    //     e.preventDefault();
    //     this.setState({popupState: false, popupStateValidation: false});
    //     this.props.onCloseOverlay();
    // }
    onValidationSucceed= async () => {
        var emptyTable = [
            {
                id: "",
                value: ""
            }
        ];
        this.setState({
            msg: "",
            popupState: false,
            popupStateValidation: false,
            boxlistValue: "",
            boxlist: emptyTable,
            subscriptionlistValue: "",
            subscriptionlist: emptyTable,
            simlistValue: "",
            simlist: emptyTable,
            errmsg: "",
            url: ""
        });
        this.props.onCloseOverlay();
    }
    onCancelation = async () => {
        this.setState({
            popupStateValidation:false,
        })
    }
    onChangeBox = async (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({boxlistValue: value});
    }
    onChangeSim = async (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({simlistValue: value});
    }
    onChangeSubscription = async (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({subscriptionlistValue: value});
    }
    componentDidMount = async () => {
        var methodName = 'new Association Box';
        var urlBoxFreeOfAssociation = "/box/list?status=free";

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO],  reception des données  des associations de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({id: data.content[i].idBox})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({boxlist: optionTmp, boxlistValue: ""});
        }.bind(this));
        //Get Sim Available list
        var urlSim = "/sim/list?status=enable";
        this.serverRequestSim = $.get(urlSim, function(result) {
            console.log('[INFO],  reception des données  des sim de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.contentJs.length; i += 1) {
                    optionTmp.push({id: data.contentJs[i].numero, idobj: data.contentJs[i].idobj})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({simlist: optionTmp, simlistValue: ""});
        }.bind(this));

        //Get Subscrption List
        var urlSubscription = "/subscription/list";
        this.serverRequestSubscription = $.get(urlSubscription, function(result) {
            console.log('[INFO],  reception des données des subscription de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.contentJs.length; i += 1) {
                    optionTmp.push({id: data.contentJs[i].name, idobj: data.contentJs[i].id})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({subscriptionlist: optionTmp, subscriptionlistValue: ""});
        }.bind(this));

    }
    componentWillUnmount() {
        try {
            this.serverRequest.abort();
            this.serverRequestSim.abort();
            this.serverRequestSubscription.abort();
        } catch (e) {}
    }
    render() {
        return (
            
            <PopUp
                title="Nouvelle Configuration Box"
                close={this.props.onCloseOverlay}
                submitAction={this.onValidation}
            >
                <Box>
                    {this.state.errmsg}
                </Box>
                <Grid container spacing={2} >
                    <Grid xs={12} sm={6}>
                        <InputSelectNative
                            label="Numéro de Box"
                            value={this.state.boxlistValue} 
                            onChange={this.onChangeBox}
                            options={this.state.boxlist.map( optionval => 
                                <option key={optionval.id} value={optionval.id}>{optionval.id}</option>
                            )}
                        />

                    </Grid>
                    {/*
                    <Grid xs={12} sm={6}>
                        <p className="c-black f-500 m-b-20">Type d'abonnement</p>
                        <div className="form-group">
                            <div className="fg-line">
                                <select className="form-control" value={this.state.subscriptionlistValue} onChange={this.onChangeSubscription}>
                                    {this.state.subscriptionlist.map( optionval => 
                                        <option key={optionval.id} value={optionval.id}>{optionval.id}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div> */}
                    <Grid xs={12} sm={6}>
                        <InputSelectNative
                            label="Numéro de SIM"
                            value={this.state.simlistValue} 
                            onChange={this.onChangeSim}
                            options={this.state.simlist.map( optionval => 
                                <option key={optionval.id} value={optionval.id}>{optionval.id}</option>
                            )}
                        />
                        {/* <p className="c-black f-500 m-b-20">Numero de SIM</p>
                        <div className="form-group fg-float">
                            <select className="form-control" value={this.state.simlistValue} onChange={this.onChangeSim}>
                                {this.state.simlist.map( optionval => 
                                    <option key={optionval.id} value={optionval.id}>{optionval.id}</option>
                                )}
                            </select>
                        </div> */}
                    </Grid>
                </Grid>

                {this.state.popupStateValidation &&
                    <ValidationOverlay
                        msg={this.state.msg}
                        // popupStateButton={this.state.popupStateValidation}
                        url={this.state.url}
                        onValidation={this.onValidationSucceed}
                        onCancelation={this.onCancelation}
                    />
                }
            </PopUp>
        );
    }
};
export default  NewBoxAssociation
